import { api } from '@/lib/axios';

export type LiasseExercice = {
  id: string;
  annee: number;
  nif: string;
  designation: string;
  activite: string;
  adresse: string;
  date_cloture: string;
  statut: string;
};

export type LigneTemplate = { type: 'section' | 'data' | 'sub' | 'total'; cle: string | null; libelle: string };
export type TableauTemplate = {
  tableau: string;
  titre: string;
  colonnes: string[];
  entetes: string[];
  col_annee: Record<string, string>;
  lignes: LigneTemplate[];
};
export type Templates = Record<string, TableauTemplate>;

export type Controle = { libelle: string; tableau: string; saisi: number; calcule: number; ecart: number; ok: boolean };
/** tableau → cle_ligne → colonne → valeur */
export type Valeurs = Record<string, Record<string, Record<string, number>>>;
export type ExerciceDetail = { exercice: LiasseExercice; valeurs: Valeurs; controles: Controle[] };

export async function getTemplates(): Promise<Templates> {
  const { data } = await api.get<Templates>('/liasse/templates');
  return data;
}
export async function listExercices(): Promise<LiasseExercice[]> {
  const { data } = await api.get<LiasseExercice[]>('/liasse/exercices');
  return data;
}
export async function getExercice(id: string): Promise<ExerciceDetail> {
  const { data } = await api.get<ExerciceDetail>(`/liasse/exercices/${id}`);
  return data;
}
export async function setValeurs(
  id: string,
  tableau: string,
  valeurs: Record<string, Record<string, number | null>>,
): Promise<void> {
  await api.put(`/liasse/exercices/${id}/valeurs`, { tableau, valeurs });
}
export async function dupliquerExercice(id: string): Promise<LiasseExercice> {
  const { data } = await api.post<LiasseExercice>(`/liasse/exercices/${id}/dupliquer`);
  return data;
}
export async function seedLiasse2023(): Promise<LiasseExercice> {
  const { data } = await api.post<LiasseExercice>('/liasse/seed-2023');
  return data;
}
export async function genererDepuisBalance(id: string): Promise<{ detail: string; controles: Controle[] }> {
  const { data } = await api.post(`/liasse/exercices/${id}/generer-balance`);
  return data;
}
export async function downloadLiasse(id: string, format: 'pdf' | 'excel', annee: number): Promise<void> {
  const { data } = await api.get(`/liasse/exercices/${id}/${format}`, { responseType: 'blob' });
  const url = URL.createObjectURL(data as Blob);
  if (format === 'pdf') {
    window.open(url, '_blank');
  } else {
    const a = document.createElement('a');
    a.href = url;
    a.download = `liasse_${annee}.xlsx`;
    a.click();
  }
  setTimeout(() => URL.revokeObjectURL(url), 10000);
}
